import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom"; // Import useNavigate and Link
import DataTable from "react-data-table-component";
import axios from "../../axios";

const BannerList = () => {
  const [banners, setBanners] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate(); // Add useNavigate hook

  const handleEdit = (id) => {
    // Use navigate instead of window.location.href
    navigate(`/admin/addBanner/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this banner?")) {
      axios
        .delete(`/banners/${id}`)
        .then(() => {
          const updated = banners.filter((banner) => banner.id !== id);
          setBanners(updated);
          setFilteredData(updated);
          alert("Banner deleted successfully!");
        })
        .catch((err) => {
          console.error("Error deleting banner:", err);
          alert("Failed to delete banner");
        });
    }
  };

  useEffect(() => {
    axios
      .get("/banners")
      .then((res) => {
        const formatted = res.data.map((item) => ({
          ...item,
          title: item.title || "Untitled Banner",
          imageUrl: item.image_url,
        }));
        setBanners(formatted);
        setFilteredData(formatted);
      })
      .catch((err) => {
        console.error("Failed to fetch banners:", err);
      });
  }, []);

  useEffect(() => {
    const filtered = banners.filter((banner) =>
      banner.title.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, banners]);

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (_, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Banner Title",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => <div className="text-center">{row.title}</div>,
    },
    {
      name: "Image",
      cell: (row) => (
        <div className="text-center">
          {row.imageUrl ? (
            <img
              src={row.imageUrl}
              alt={row.title}
              style={{ width: "80px", height: "auto", objectFit: "cover" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/no-image"; // Optional fallback image
              }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header">
        <h4>Banners</h4>

        <Link to="/admin/addBanner" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Banner</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search banner..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No data found</div>
          }
        />
      </div>
    </div>
  );
};

export default BannerList;
